<template>
	<div class="barBoxHeight">
		<div class="titleIcon">
			<div class="inlin">
				<i :class="`iconfont ${icon} tableIcon`"></i>
				<span class="fz14">{{title}}</span>
			</div>
		</div>
		<div class="portraitLine disflex" ref="breadcrumb">
			<div class="reportTab" v-if="colorList&&reportList&&reportList.length>0">
				<span v-for="(item,index) in reportScreening" :key="index" :class="num==index?'activelinetab':''"
				@click="reportClick(item,index)">{{item.name}}
				<span class="spanlinetab" :style="{background:(num==index?colorList[0]:'transparent')}"></span>
				</span>
			</div>
			<div v-if="reportList&&reportList.length>0" ref="nationwide">
				<div class="echarts">
					<div :id="echarts" class="barchartsHeight" ref="echarts"></div>
				</div>
			</div>
			<div v-else class="echartslineNull">
				<div class="icon">
					<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
				</div>
				<div class="text">暂无数据</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import echarts from 'echarts'
	export default {
		props:['name','colorList','icon','title','reportList','chartsType','breadcrumbType'],
		data() {
			return {
				myChart: null,
				height: 25,
				barMaxWidth: 7,
				num:0
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList','GetReportListArr']),
			...Vuex.mapState('breadcrumb', ['reportScreening']),
			...Vuex.mapState('visualization', ['trigger']),
			echarts() {
			  return 'echarts' + parseInt(Math.random() * 100);
			}
		},
		mounted() {
			//左侧导航收起时右侧图联动
			let _this = this;
			
			this.$nextTick(()=>{
				_this.getEcharts();
			})
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (_this.myChart) {
					let dom = document.getElementById(_this.echarts);
					if (dom) {
						dom.style.width = _this.$refs.nationwide.offsetWidth - 40 + "px";
						_this.myChart.resize();
						_this.getEcharts();
					}
				}
			})
		},
		watch: {
			reportList(old, news) {
				let _this = this;
				if (this.trigger.hospital) {
					this.trigger.hospital = false;
					this.$nextTick(() => {
						_this.getEcharts();
					})
				}
			}
		},
		updated() {
			let _this = this;
			if (this.trigger.hospital) {
				this.trigger.hospital = false;
				this.$nextTick(() => {
					_this.getEcharts();
				})
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType','clearRow']),
			...Vuex.mapMutations('supervisor',['currentChangesSecond','setBreadcrumbList']),
			// ...Vuex.mapMutations('supervisor', ['']),
			// ...Vuex.mapActions('visualization', ['GetQCedReportMonthly']),
			getCaption(obj){
			    var index=obj.lastIndexOf("\-");
			    obj=obj.substring(index+1,obj.length);
			    return obj.replace(/\b(0+)/gi,"");
			},
			reportClick(item,index){
				this.num = index;
				this.$emit(this.name,item)
			},
			getEcharts() {
				let _this = this;
				let data = [];
				let value = [];
				let value1 = [];
				let color = [_this.colorList[0]];
				let dom = document.getElementById(_this.echarts);
				this.height = 14.5;
				this.barMaxWidth = 7;
				if (this.reportList&&this.reportList.length > 0) {
					this.reportList.forEach(element => {
						data.push({
							value: this.getCaption(element.Month) + '月'
						})
						value.push({
							value: element.ReportCount,
							Month: element.Month,
							type:2
						})
						value1.push({
							value: element.ImageCount,
							Month: element.Month,
							type:3
						})
					})
				} else {
					data = [];
					value = [];
					value1 = [];
				}
				if (dom) {
					dom.style.width = this.$refs.breadcrumb.offsetWidth + "px";
					dom.style.height = this.$refs.breadcrumb.offsetHeight - 15 + "px";
					this.myChart = echarts.init(dom);
				}
				let option = null;
				option = {
					color: color,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'none'
						},
						formatter: function(params, ticket, callback) {
							return `报告数: ${params[0].value}份`;
						},
					},
					legend: {
						data: ['报告', '影像'],
						itemHeight: this.fontSize(0.10),
						itemWidth: this.fontSize(0.10),
						textStyle:{
							fontSize: this.fontSize(0.10),
							color:'#ffffff'
						},
						top:26,
						x: 'right'
					},
					toolbox: {
						feature: {
							magicType: {
								show: true, 
								type: [ 'bar','line'],
								title : {
									line : '',
									bar : '',
								},
								iconStyle:{
									borderColor:'#ffffff'
								},
								emphasis:{
									iconStyle:{
										borderColor:_this.colorList[0]
									},
								}
							},
						}
					},
					grid: {
						left: this.fontSize(0.20),
						right: this.fontSize(0.10),
						bottom: 0,
						height: "61%",
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: data,
						triggerEvent: true,
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							interval:0,
							textStyle: {
								color: '#ffffff',
								fontSize: this.fontSize(0.08)
							}
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff',
								fontSize: this.fontSize(0.08)
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [{
						barMaxWidth: this.barMaxWidth,
						name: '报告',
						type: _this.chartsType,
						itemStyle: {
							normal: {
								barBorderRadius: [20, 20, 20, 20],
								lineStyle:{
									width:1//设置线条粗细
								},
								color: new echarts.graphic.LinearGradient(
									0, 0, 1, 1,
									[
										{offset: 0, color: _this.colorList[1]},                 //柱图渐变色
										{offset: 1, color: _this.colorList[0]},                   //柱图渐变色
									]
								)
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0.5,
									color: 'RGBA('+_this.colorList[0].colorRgb()+', .5)'
								}, {
									offset: 1,
									color: 'RGBA('+_this.colorList[0].colorRgb()+', 0)'
								}],
								global: false // 缺省为 false
							}
						},
						symbol: 'circle',     //设定为实心点
						symbolSize: 1,   //设定实心点的大小
						data: value,
					},{
						barMaxWidth: this.barMaxWidth,
						name: '影像',
						type: _this.chartsType,
						itemStyle: {
							normal: {
								barBorderRadius: [20, 20, 20, 20],
								lineStyle:{
									width:1//设置线条粗细
								},
								color: new echarts.graphic.LinearGradient(
									0, 0, 1, 1,
									[
										{offset: 0, color: _this.colorList[4]},                 //柱图渐变色
										{offset: 1, color: _this.colorList[3]},                   //柱图渐变色
									]
								)
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0.5,
									color: 'RGBA('+_this.colorList[3].colorRgb()+', .5)'
								}, {
									offset: 1,
									color: 'RGBA('+_this.colorList[3].colorRgb()+', 0)'
								}],
								global: false // 缺省为 false
							}
						},
						symbol: 'circle',     //设定为实心点
						symbolSize: 1,   //设定实心点的大小
						data: value1,
					}]
				};
				if (option && typeof option === "object"&&this.myChart) {
					this.myChart.clear()
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.setTootipType(false);
						this.clearRow();
						this.currentChangesSecond(1);
						this.setBreadcrumbList();
						this.breadcrumbList.push(params.data.Month.split('-').join('/') + '-' + params.data.Month.split('-').join('/'));
						this.GetReportListArr.type = params.name;
						this.breadcrumbList.push(this.title + params.name);
						this.GetReportListArr.name = this.title + params.name;
						this.GetReportListArr.tabType = params.data.type;
						if (this.breadcrumbType == 'regionFfalse') {
							this.breadcrumbList.push("doubleLineregionFfalse");
						}else{
							this.breadcrumbList.push("doubleLine");
						}
						this.$router.push("/home/supervisor/qualifiedTable");
					});

					this.myChart.resize(); //区域更新
					window.addEventListener("resize", () => {
						this.myChart.resize();
					});
				}
			}
		}

	}
</script>

